import React from 'react';
import DENTModalOverviewGeneralSection from '../DENTModalOverviewGeneralSection/DENTModalOverviewGeneralSection';
import DENTModalOverviewGeneralEndodonticRow from './DENTModalOverviewGeneralEndodonticRow';
import {
	ENDODONTIC_BUTTON_OPTIONS,
	EndodonticButtonOption,
} from '../../Helpers/endodontic/endodonticButtonOptions';

interface Props {
	selectTest: (test: EndodonticButtonOption['value']) => void;
}

const DENTModalOverviewGeneralEndodontic = ({ selectTest }: Props) => {
	return (
		<DENTModalOverviewGeneralSection
			title={'patientTreatment.meddiDENT.dentalCross.endodontic.title'}>
			{ENDODONTIC_BUTTON_OPTIONS.map(row => (
				<DENTModalOverviewGeneralEndodonticRow
					{...row}
					key={row.value}
					selectTest={selectTest}
				/>
			))}
		</DENTModalOverviewGeneralSection>
	);
};

export default DENTModalOverviewGeneralEndodontic;
